import { lazy } from "react";

export const LazySignUpRoot = lazy(() =>
  import(/* webpackChunkName: "retailer-sign-up-2" */ "./SignUpRoot").then(
    (m) => ({ default: m.SignUpRoot })
  )
);
